// The BASE message dictionary — the strings the foundation's own components
// render (auth screens, principal context, the four-eyes banner, the shell
// chrome, generic errors). Turkish-first (ADR 0015 §7). Each app MERGES its own
// surface strings on top and OVERRIDES `app.title` with its product name; the
// foundation keeps a brand-neutral default so its components render standalone.
export const baseTr = {
  "app.title": "CSA Privé",
  "auth.login": "Giriş yap",
  "auth.logout": "Çıkış",
  "auth.loading": "Oturum yükleniyor…",
  "auth.signin_prompt": "Devam etmek için personel hesabınızla giriş yapın.",
  "principal.loading": "Profil yükleniyor…",
  "principal.error": "Profil yüklenemedi.",
  "fourEyes.pending": "İkinci onay bekleniyor",
  "error.generic": "Bir hata oluştu",
} as const;

export type BaseMessageKey = keyof typeof baseTr;

export const baseEn: Record<BaseMessageKey, string> = {
  "app.title": "CSA Privé",
  "auth.login": "Sign in",
  "auth.logout": "Sign out",
  "auth.loading": "Loading session…",
  "auth.signin_prompt": "Sign in with your staff account to continue.",
  "principal.loading": "Loading profile…",
  "principal.error": "Could not load profile.",
  "fourEyes.pending": "Awaiting second approval",
  "error.generic": "Something went wrong",
};

export const baseDictionaries = { tr: baseTr, en: baseEn } as const;
